module.exports = __webpack_public_path__ + "static/img/feiji.406d5a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/feiji.png
// module id = LLvT
// module chunks = 1